import ManageProtocole from '@/views/consultations/en-cours/protocole-soins/manage-protocole'
import ManageEditProtocole from '@/views/consultations/en-cours/protocole-soins/manage-edit-protocole'
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';

import $ from 'jquery'

export default {
    name: 'protocole-soins',
    components: {
        ManageProtocole, EnteteBonEtFacture, 
        ManageEditProtocole
    },
    props: {
        mode_urgence: Boolean,
        active_role: String,
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object,
        info_assurance_patient: {
            type: Object, 
            default: () => {}
        }
    },
    data() {
        return {
            is_loading: false,
            is_empty: true,
            load_error: false,
            state_toggler: 0,
            selected_protocole: {},
            selected_cat_consigne: {},
            selected_protocole_hn: [],

            format_ordonnace: 'a5',    
            width_ordonnance: '559px',
            font_size: 'font-12',
            filename: '',
            ordonnance_to_print: {},
            info_patient: {},
            info_caissier: {},

            info_user: {},

            data_type: '',
            model_facturation_acte: '',
            editing_medicament: {},
            editing_consommable: {},
            editing_acte: {},
            editing_protocole_a_suivre: [],
            edit_toggler: 0,
            protocole_id: 0,
            is_admission_edit: 0,
            historique_modifications: [],
            label_historique: '',
            data_to_be_deleted: {},
            del_toggler: 0
        }
    },

    watch: {
        evolution_toggler() {
            this.getListeProtocoleSoins()

            const t = new Date()
            this.filename = 'Ordonnance_'+this.patient.nom+' '+this.patient.prenoms+'_'+t.getTime()

            this.userInfoSetter()
            this.$store.commit("SET_CAN_PRINT_SOINS_ORDONNANCE", false)
            this.$store.commit("SET_SOINS_ORDONNANCE_TO_PRINT", {})
        }
    },

    computed: {
        peut_planifier() {
            const modifiable = Number(this.consultation.is_end) === 0 ||
                (this.active_role === 'ROLE_MEDECIN' && this.consultation.complement && this.consultation.complement.jusqu_au)
            return !!modifiable && Number(this.current_consultation_evolution) === Number(this.evolution_id) &&
                (Number(this.is_start) === 1 || this.mode_urgence && this.active_role === 'ROLE_INFIRMIER' && Number(this.is_start) === 0)
        },
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        consultation_protocoles_soins() {
            return this.$store.getters['consultation_protocoles_soins'];
        },

        patient(){
            return this.$store.getters['patient'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        }
    },

    mounted() {
        if (this.mode_urgence) { this.getListeProtocoleSoins(); this.userInfoSetter() }
    },

    methods: {
        libelleEtapeSoin(protocole, prise) {
            if (prise.protocole_hn === null || prise.protocole_hn === undefined) return '⚡ Immédiat'
            const intervalle = Number(protocole.intervalle_minutes)
            const rang = Number(prise.protocole_hn)
            if (!intervalle || !Number.isFinite(rang)) return `H${prise.protocole_hn}`
            const minutes = intervalle * rang
            if (minutes === 0) return 'H0'
            return minutes < 60 ? `M${minutes}` : (minutes % 60 === 0 ? `H${minutes / 60}` : `+${minutes} min`)
        },
        userInfoSetter() {
            this.info_patient = {
                nom_patient: this.patient.nom+' '+this.patient.prenoms,
                sexe: (this.patient.sexe_id == 1)?'M':(this.patient.sexe_id == 2)?'F':'',
                telephone: this.patient.telephone_mobile,
                num_dossier: this.patient.code,
                age: this.patient.age
            }

            this.info_caissier = {
                nom_caissier: this.userCredentials.name,
                titre: this.userCredentials.titre
            }

            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        addProtocole() {
            if (!this.peut_planifier) return
            this.protocole_id = 0
            this.selected_protocole = {}
            this.is_admission_edit = 0
            this.state_toggler = (this.state_toggler === 0)?1:0
            $('.prot-modal'+this.evolution_id).modal('show')
        },

        addNewProtocoleItem(protocole) {
            this.state_toggler = (this.state_toggler === 0)?1:0
            this.is_admission_edit = 0

            this.selected_protocole = protocole
            this.protocole_id = protocole.protocole_id
            $('.prot-modal'+this.evolution_id).modal('show')
        },

        editCatConsigne(protocole, cat, evolution_id) {
            this.selected_cat_consigne = cat
            this.selected_protocole = protocole
            this.selected_protocole.evolution_id = evolution_id
        },

        addCatConsigne(protocole, evolution_id) {
            this.selected_cat_consigne = {
                cat_id: 0
            }
            this.selected_protocole = protocole
            this.selected_protocole.evolution_id = evolution_id
        },

        getListeProtocoleSoins() {
            this.is_loading = true
            this.load_error = false

            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                est_encours: true
            }
            return this.$store.dispatch('getConsultationProtocoleSoins', data).then(() => {
                if (this.consultation_protocoles_soins.length == 0) {
                    this.is_empty = true 
                } else {
                    this.is_empty = false
                }

            }).catch(() => {
                this.load_error = true
            }).finally(() => {
                this.is_loading = false
            })
        },
        
        dropContent(index) {
            var el = document.getElementById('dc'+index)

            // Check if element has class show
            if ($('#dc'+index).hasClass("show")) {
                el.classList.remove('show')
            } else {
                el.classList.add('show')
            }
        },

        printOrdonnance(ordonnance) {
            this.$store.commit("SET_CAN_PRINT_SOINS_ORDONNANCE", true)
            this.$store.commit("SET_SOINS_ORDONNANCE_TO_PRINT", ordonnance)
        },

        setCatToDelete(cat, protocole, evolution_id) {
            this.selected_cat_consigne = cat
            this.selected_protocole = protocole
            this.selected_protocole.evolution_id = evolution_id
        },

        setProtocoleToDelete(protocole, evolution_id) {
            this.del_toggler = (this.del_toggler === 0)?1:0
            this.selected_protocole = protocole
            this.selected_protocole.evolution_id = evolution_id
        },

        editAdmission(protocole) {
            this.state_toggler = (this.state_toggler === 0)?1:0
            this.protocole_id = protocole.protocole_id
            this.is_admission_edit = 1

            this.selected_protocole = protocole
            $('.prot-modal'+this.evolution_id).modal('show')
        },

        editMedicament(data, protocoles_a_suivre) {
            this.historique_modifications = []
            this.edit_toggler = (this.edit_toggler == 0)?1:0
            this.data_type = 'medicament'
            const medicament = data.medicament

            const protocole = protocoles_a_suivre.filter(prot => prot.medicament === medicament);
            this.editing_medicament = data
            this.editing_protocole_a_suivre = protocole[0].prot_a_suivre

            $('.edit-medoc'+this.evolution_id).modal('show')
        },

        editConsommable(data) {
            this.historique_modifications = []
            this.edit_toggler = (this.edit_toggler == 0)?1:0
            this.data_type = 'consommable'
            this.editing_consommable = data

            $('.edit-medoc'+this.evolution_id).modal('show')
        },

        editActe(data) {
            this.historique_modifications = []
            this.edit_toggler = (this.edit_toggler == 0)?1:0
            this.data_type = 'acte'
            this.editing_acte = data

            $('.edit-medoc'+this.evolution_id).modal('show')
        },

        fetchModelFacturation(protocole) {
            this.model_facturation_acte = protocole.model_facturation_acte
        },

        viewHistoriqueModifications(historique, libelle) {
            this.label_historique = libelle
            this.historique_modifications = historique
            $('.view-histo'+this.evolution_id).modal('show')
        },

        setItemToDelete(protocole, data_type, item) {
            let libelle = ''
            if (data_type == 'medicament') {
                libelle = item.medicament
            } else if(data_type == 'consommable') {
                libelle = item.consommable
            } else if (data_type == 'acte') {
                libelle = item.acte
            }
            this.data_to_be_deleted = {
                libelle: libelle,
                data_type: data_type,
                id: item.prestation_id,
                protocole_id: protocole.protocole_id,
                constitution_protocole_id: item.constitution_protocole_id
            }

            $('.del-prot-item'+this.evolution_id).modal('show')
        }
    }
}
